<style lang="scss">
.layout {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

header {
    background: #fff;
    padding: 15px 25px;
    box-shadow: 0px 1px 4px rgba(21, 34, 50, 0.08);
    flex: 0 0;
    position: relative;
    z-index: 2;
}

.logo {
    width: 44px;
    height: 40px;
}

.body {
    display: flex;
    flex: 1 1 100%;
    overflow: hidden;
}

.lecture-title {
    margin-top: 40px;
}

nav {
    background: #fff;
    width: 320px;
    flex: 0 0 320px;
}

main {
    flex: 1 1 100%;
    padding: 30px;
    overflow: auto;
}
</style>
<script lang="ts">
import router from '../store/router';
import courses from '../store/courses';
import type { CourseListItem, LectureListItem } from '../api/types';
import CourseList from '../components/CourseList.svelte';
import Course from '../components/Course.svelte';
import LectureList from '../components/LectureList.svelte';
import Lecture from '../components/Lecture.svelte';
import ErrorPopup from '../components/ErrorPopup.svelte';

let selectedCourse: CourseListItem | undefined;
let selectedLecture: LectureListItem | undefined;

$: selectedCourse = $courses.courses[$courses.selectedCourse];
$: selectedLecture = $courses.lectures[$courses.selectedLecture];

courses.init();
router();
</script>
{#if $courses.error}
    <ErrorPopup error={$courses.error} on:close={() => courses.resetError()} />
{/if}
<div class="layout">
    <header>
        <img src="/logo.png" alt="Корни и Крылья" class="logo" />
    </header>

    <div class="body">
        <nav>
            <CourseList />
        </nav>
        <main>
            {#if selectedCourse}
                <h2>Общие данные по курсу</h2>
                <Course course={selectedCourse} on:submit={e => courses.updateCourse(e.detail)} />
                <h2 class="lecture-title">Лекции</h2>
                <LectureList course={selectedCourse} selected={$courses.selectedLecture} />

                {#if selectedLecture}
                    <Lecture courseId={selectedCourse.id} lecture={selectedLecture} on:submit={e => courses.updateLecture(e.detail)} />
                {/if}
            {/if}
        </main>
    </div>
</div>
